"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _merge = _interopRequireDefault(require("lodash/merge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const withAnalytics = (analyticsConfig, getPageName = undefined) => WrappedComponent => {
  const pageNameConstructor = getPageName !== undefined && typeof getPageName === 'function' ? getPageName : location => {
    const basename = location.basename.split('/').slice(3).join('/');
    const pathname = location.pathname === '/' ? '' : location.pathname;
    return `${basename}${pathname}`;
  };
  class Analytics extends _react.Component {
    constructor(props) {
      super(props);
      const {
        location,
        prov,
        lang
      } = this.props;
      this.defaultConfig = {
        page: {
          name: pageNameConstructor(location),
          province: prov,
          language: lang
        },
        event: {},
        user: {}
      };
      if (typeof analyticsConfig === 'function') {
        this.config = (0, _merge.default)(this.defaultConfig, analyticsConfig(this.props));
      } else {
        this.config = (0, _merge.default)(this.defaultConfig, analyticsConfig);
      }
    }
    componentDidMount() {
      if (typeof window !== 'undefined') {
        window.dataLayer = this.config;
      }
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, this.props);
    }
  }
  Analytics.WrappedComponent = WrappedComponent;
  Analytics.propTypes = {
    prov: _propTypes.default.string,
    lang: _propTypes.default.string,
    location: _propTypes.default.shape({
      basename: _propTypes.default.string,
      pathname: _propTypes.default.string.isRequired
    })
  };
  Analytics.defaultProps = {
    prov: 'bc',
    lang: 'en',
    location: undefined
  };
  return Analytics;
};
var _default = withAnalytics;
exports.default = _default;